export { default } from './ownership-stake';
